import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-circle-check",
  "use": "default-circle-check-usage",
  "viewBox": "0 0 138 138",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 138 138\" id=\"default-circle-check\"><path d=\"M69 138c38.108 0 69-30.892 69-69 0-38.108-30.892-69-69-69C30.892 0 0 30.892 0 69c0 38.108 30.892 69 69 69zm0-4c-35.899 0-65-29.101-65-65S33.101 4 69 4s65 29.101 65 65-29.101 65-65 65z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol